import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Whatmob() {
  return (
    <section className="what_mob p-100 text_second_text">
      <Container>
        <Row>
          <Col
            xs={12}
            md={10}
            lg={10}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <h2>Highlights</h2>
            <p>
              The project's highlights included the timely completion of the
              app, meeting user expectations.
            </p>
            <p>
              The smooth integration of the 3D model enhanced the app's visual
              appeal and user engagement.
            </p>
            <p>
              Accurate lip and sound synchronization significantly improved the
              realism of the AI chatbot interaction, providing a more immersive
              user experience.
            </p>
            <div className="what_mob_img">
              <StaticImage
                src="../../../images/case-studies/truth-gpt/Highlights.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={1253}
                height={638}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Whatmob;
